<header>
    <div class="text" mat-dialog-title>{{ title || 'Confirm' }}</div>
</header>
<mat-dialog-content>
    <div class="body">
        <app-icon *ngIf="icon" [icon]="icon"></app-icon>
        <div class="content">
            <p [innerHTML]="content || 'Are you sure?'"></p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button *ngIf="!hide_cancel" mat-button class="error" name="cancel" (tapped)="close()">
        {{ cancel || 'Cancel' }}
    </button>
    <button mat-button name="accept" (tapped)="accept()">{{ action || 'Ok' }}</button>
</mat-dialog-actions>
